import { render, staticRenderFns } from "./MobileFullPageWrapper.vue?vue&type=template&id=d46e96b0&scoped=true"
import script from "./MobileFullPageWrapper.vue?vue&type=script&lang=js"
export * from "./MobileFullPageWrapper.vue?vue&type=script&lang=js"
import style0 from "./MobileFullPageWrapper.vue?vue&type=style&index=0&id=d46e96b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46e96b0",
  null
  
)

export default component.exports